import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { RoundedButton, RoundedTextField } from '../../components/Form';
import RoundedTelInput from '../../components/Form/RoundedTelInput';
import { Stack } from '@mui/system';
import { handleAlert } from '../../utils/handleAlert';
import { contactSupportAPI } from '../../api/requests/contactSupportAPI';
import { matchIsValidTel } from 'mui-tel-input';

const validEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function GenericSupportForm() {
  const [info, setInfo] = useState({
    name: '',
    email: '',
    phoneNumber: '+91',
    description: '',
  });

  const [loading, setLoading] = useState(false);

  function handleInfo(key, val) {
    setInfo((prev) => ({ ...prev, [key]: val }));
  }

  async function handleSubmit() {
    const { name, email, phoneNumber, description } = info;

    if (Object.values(info).some((val) => val.length === 0)) {
      return handleAlert('Please fill all the fields', 'error');
    }

    if (!matchIsValidTel(phoneNumber)) {
      return handleAlert('Please enter a valid phone number', 'error');
    }

    if (!email.match(validEmailRegex)) {
      return handleAlert('Please enter a valid email address', 'error');
    }

    try {
      setLoading(true);
      const nameArr = name.split(' ');

      const data = {
        firstName: nameArr[0],
        lastName: nameArr[1] ?? ' ',
        email: email,
        phoneNumber: phoneNumber,
        description: description,
      };

      await contactSupportAPI.contactSupport(data);

      handleAlert("Details Submitted Successfully. We'll get back to you soon", 'success');

      setInfo({
        name: '',
        email: '',
        phoneNumber: '+91',
        description: '',
      });
    } catch (err) {
      handleAlert('Something went wrong, please try again later', 'error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <React.Fragment>
      <Stack
        sx={{
          gap: 4,
          px: '1.5rem',
          flexDirection: 'column',
          '& > .input-wrapper': {
            gap: 1.5,
            flexDirection: 'column',

            '& .label': {
              fontWeight: 400,
              fontSize: '0.95rem',
            },
          },
        }}
      >
        <Stack className="input-wrapper">
          <Typography variant="body2" className="label">
            Name
          </Typography>

          <RoundedTextField
            placeholder="Enter your full name"
            size="small"
            fullWidth
            value={info.name}
            onChange={(e) => handleInfo('name', e.target.value)}
          />
        </Stack>
        <Stack className="input-wrapper">
          <Typography variant="body2" className="label">
            Email Id
          </Typography>

          <RoundedTextField
            placeholder="Enter your email id"
            size="small"
            fullWidth
            value={info.email}
            onChange={(e) => handleInfo('email', e.target.value)}
          />
        </Stack>
        <Stack className="input-wrapper">
          <Typography variant="body2" className="label">
            Phone Number
          </Typography>

          <RoundedTelInput
            fullWidth
            value={info.phoneNumber}
            onChange={(e) => handleInfo('phoneNumber', e)}
          />
        </Stack>
        <Stack className="input-wrapper">
          <Typography variant="body2" className="label">
            Write your query
          </Typography>

          <RoundedTextField
            placeholder="Please share your query"
            multiline
            rows={4}
            size="small"
            fullWidth
            value={info.description}
            onChange={(e) => handleInfo('description', e.target.value)}
          />
        </Stack>
      </Stack>

      <Stack
        sx={{ position: 'sticky', bottom: '0', padding: '1.5rem', backdropFilter: 'blur(10px)' }}
      >
        <RoundedButton fullWidth variant="contained" onClick={handleSubmit} loading={loading}>
          Submit
        </RoundedButton>
      </Stack>
    </React.Fragment>
  );
}
